<template>
    <!-- 확인 필요 목록 — 헤더 ⚠ / 홈 카드에서 'openTodoModal' {type} 로 열림. 데이터는 utils/todoStore -->
    <Transition name="fade">
        <div class="modal-area" v-if="is_open" style="z-index: 1090;" tabindex="-1" ref="todoModal" @keyup.esc="is_open = false" @click.self="is_open = false">
            <div class="modal-wrapper todo-wrapper">
                <div class="modal-container todo-container">
                    <div class="todo-header">
                        <h3 class="todo-title">확인 필요</h3>
                        <span class="todo-sub">처리하면 목록에서 사라집니다.</span>
                        <button type="button" class="btn-close ms-auto" @click="is_open = false"></button>
                    </div>
                    <div class="todo-tabs">
                        <button v-for="t in TODO_TYPES" :key="t.key" type="button" class="todo-tab" :class="type == t.key ? 'on' : ''" @click="type = t.key">
                            <i class="bi" :class="t.icon"></i> {{ t.label }}<span class="todo-tab-count" :class="state.counts[t.key] ? 'has' : ''">{{ state.counts[t.key] || 0 }}</span>
                        </button>
                    </div>
                    <p class="todo-desc">{{ currentType.desc }}</p>

                    <div class="todo-body">
                        <p v-if="state.loading && list.length == 0" class="todo-empty">불러오는 중…</p>
                        <p v-else-if="list.length == 0" class="todo-empty">확인할 항목이 없습니다.</p>
                        <div v-for="i in list" :key="i.type + i.ref_key" class="todo-row">
                            <img v-if="i.animal_image" :src="i.animal_image" class="todo-img" alt=""/>
                            <div v-else class="todo-img todo-img-empty"><i class="bi bi-image"></i></div>
                            <div class="todo-main">
                                <!-- 이름이 없으면 공고번호를 이름 자리에 크게 -->
                                <p class="todo-name" v-if="i.animal_name">{{ i.animal_name }} <span class="todo-notify">{{ i.notify_number }}</span></p>
                                <p class="todo-name" v-else>{{ i.notify_number }}</p>
                                <p class="todo-detail">
                                    <template v-if="i.type == 'kit'">
                                        {{ i.title || '키트 재검사' }} · 예정일 {{ i.date }}
                                        <span class="todo-badge" :class="i.days < 0 ? 'red' : 'orange'">{{ i.days < 0 ? Math.abs(i.days) + '일 지남' : (i.days == 0 ? '오늘' : 'D-' + i.days) }}</span>
                                    </template>
                                    <template v-else-if="i.type == 'vaccine'">
                                        {{ i.title || '접종' }}{{ i.dose ? ' ' + i.dose + '차' : '' }} · 예정일 {{ i.date }}
                                        <span class="todo-badge" :class="i.days < 0 ? 'red' : 'orange'">{{ i.days < 0 ? Math.abs(i.days) + '일 지남' : (i.days == 0 ? '오늘' : 'D-' + i.days) }}</span>
                                    </template>
                                    <template v-else-if="i.type == 'adopt_mismatch'">
                                        {{ i.animal_state }} · 신청서 {{ i.request_count }}건 중 입양완료 없음{{ i.open_count ? ' (대기·상담 ' + i.open_count + '건)' : '' }} · 마지막 신청 {{ i.date }}
                                    </template>
                                    <template v-else-if="i.type == 'ended_open'">
                                        {{ i.animal_state }} · 대기·상담 신청서 {{ i.open_count }}건 남음 · 마지막 신청 {{ i.date }}
                                    </template>
                                    <template v-else>
                                        신청자 {{ i.title || '-' }} · {{ i.date }} <span class="todo-badge orange">{{ i.days }}일째 대기</span>
                                    </template>
                                </p>
                            </div>
                            <div class="todo-actions">
                                <button type="button" class="btn btn-sm btn-orange todo-btn" @click="goDetail(i)">{{ i.type == 'vaccine' || i.type == 'kit' ? '동물 보기' : '신청서 보기' }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script>
import { todoState, TODO_MODAL_TYPES as TODO_TYPES } from '@/utils/todoStore';

export default {
    name: 'TodoModal',
    data() {
        return { is_open: false, type: 'vaccine', TODO_TYPES, state: todoState };
    },
    computed: {
        currentType() {
            return TODO_TYPES.find(t => t.key == this.type) || TODO_TYPES[0];
        },
        list() {
            return (this.state.items && this.state.items[this.type]) || [];
        },
    },
    methods: {
        //params: { type } — 없으면 건수가 있는 첫 종류
        open(params) {
            const t = params && params.type;
            this.type = TODO_TYPES.find(x => x.key == t) ? t : (TODO_TYPES.find(x => this.state.counts[x.key] > 0) || TODO_TYPES[0]).key;
            this.is_open = true;
            this.$nextTick(() => { if (this.$refs.todoModal) this.$refs.todoModal.focus(); });
        },
        goDetail(i) {
            this.is_open = false;
            //관리자: 이동한 화면도 이 보호소로 (각 화면이 쿠키로 선택 보호소를 기억)
            if (this.$root.isAdmin && this.state.shelter) {
                this.$cookies.set('adminAnimalManageShelter', this.state.shelter);
                this.$cookies.set('adminAdoptionManageShelter', this.state.shelter);
            }
            if (i.type == 'vaccine' || i.type == 'kit') this.$router.push({ path: '/animal', query: { notify: i.notify_number } });
            //입양 관련: 지금 화면에 입양신청서 상세 창이 있으면(동물관리·입양관리) 그 자리에서 바로, 없으면 입양관리로 가서 열기
            else {
                const idx = String(i.request_idx || i.ref_key);
                const handlers = this.emitter.all && this.emitter.all.get('openAdoptRequestDetailModal');
                if (handlers && handlers.length) this.openRequestHere(idx);
                else this.$router.push({ path: '/adoption', query: { request: idx } });
            }
        },
        //입양관리 목록에서 행을 누를 때와 같게: 비공개면 막고, 접근 기록
        openRequestHere(idx) {
            const sd = this.state.shelter;
            this.axios.get(`/shelter/adoption/request/${encodeURIComponent(idx)}${sd ? '?shelter_device_number=' + encodeURIComponent(sd) : ''}`)
                .then(res => {
                    const r = res.data;
                    if (!r || !r.idx) throw new Error('none');
                    const e = r.exposure == null ? '' : String(r.exposure).trim().toUpperCase();
                    if (e == 'OFF' || e == 'N' || e == '0' || e == 'FALSE') {
                        alert('신청서가 취소되었습니다. 개인정보 보호를 위해 상세히 볼 수 없습니다.');
                        return;
                    }
                    this.emitter.emit('openAdoptRequestDetailModal', r);
                    this.$root.insertAccessLog('입양신청 상세 조회', '확인 필요', JSON.stringify(r), null);
                })
                .catch(() => { alert('신청서를 찾을 수 없습니다.'); });
        },
    },
    mounted() {
        this.emitter.off('openTodoModal', this.open);
        this.emitter.on('openTodoModal', this.open);
    },
    beforeUnmount() {
        this.emitter.off('openTodoModal', this.open);
    },
};
</script>

<style scoped>
    .todo-container p, .todo-container button, .todo-container span { font-size: 13.5px !important; }
    .todo-wrapper { width: min(760px, 96vw); margin: 4vh auto; }
    .todo-container { max-height: 88vh; display: flex; flex-direction: column; overflow: hidden; padding: 0 !important; text-align: left; }
    .todo-header { display: flex; align-items: center; gap: 10px; padding: 12px 16px; border-bottom: 1px solid #ececec; }
    .todo-title { font-size: 17px; font-weight: 700; margin: 0; color: #222; }
    .todo-container .todo-sub { color: #9a9a9a; font-size: 12.5px !important; }
    .todo-tabs { display: flex; flex-wrap: wrap; gap: 6px; padding: 12px 16px 0; }
    .todo-container .todo-tab { border: 1px solid #e0e0e0; background: #fff; color: #666; border-radius: 16px; padding: 4px 12px; }
    .todo-container .todo-tab.on { border-color: #f6951c; background: #FFF4E5; color: #f6951c; font-weight: 700; }
    .todo-container .todo-tab-count { margin-left: 5px; font-size: 11.5px !important; font-weight: 700; color: #b0b0b0; }
    .todo-container .todo-tab-count.has { color: #E53935; }
    .todo-container .todo-desc { color: #8a8a8a; font-size: 12.5px !important; margin: 8px 16px 6px !important; }
    .todo-body { flex: 1; overflow-y: auto; padding: 4px 16px 14px; }
    .todo-container .todo-empty { color: #a0a0a0; text-align: center; padding: 36px 0; margin: 0 !important; }
    .todo-row { display: flex; align-items: center; gap: 12px; padding: 10px 0; border-bottom: 1px solid #f0f0f0; }
    .todo-row:last-child { border-bottom: none; }
    .todo-img { width: 48px; height: 48px; border-radius: 8px; object-fit: cover; flex: none; background: #f3f3f3; }
    .todo-img-empty { display: flex; align-items: center; justify-content: center; color: #c0c0c0; }
    .todo-main { flex: 1; min-width: 0; }
    .todo-container .todo-name { font-weight: 700; color: #333 !important; margin: 0 0 2px !important; }
    .todo-container .todo-notify { color: #9a9a9a; font-weight: 500; font-size: 12px !important; margin-left: 4px; }
    .todo-container .todo-detail { color: #666 !important; margin: 0 !important; font-size: 12.5px !important; }
    .todo-container .todo-badge { font-weight: 700; font-size: 11.5px !important; border-radius: 8px; padding: 1px 7px; margin-left: 4px; }
    .todo-badge.red { color: #E53935; background: #FDECEC; }
    .todo-badge.orange { color: #f6951c; background: #FFF2E2; }
    .todo-actions { display: flex; gap: 6px; flex: none; }
    .todo-container .todo-btn { padding: 4px 10px; font-weight: 700; white-space: nowrap; }
    /* 모바일: 아래 시트(공통 .modal-area 규칙) 가로 꽉 차게, 버튼은 줄 아래 크게 */
    @media (max-width: 768px) {
        .todo-wrapper { width: 100% !important; margin: 0 !important; }
        .todo-container { max-height: 88dvh; }
        .todo-container .todo-sub { display: none; }
        .todo-header .btn-close { padding: 10px; }
        .todo-tabs { flex-wrap: nowrap; overflow-x: auto; padding-bottom: 2px; }
        .todo-container .todo-tab { flex: none; padding: 7px 14px; }
        .todo-row { flex-wrap: wrap; }
        .todo-actions { width: 100%; justify-content: flex-end; }
        .todo-container .todo-btn { flex: 1; min-height: 40px; }
        .todo-body { padding-bottom: calc(14px + env(safe-area-inset-bottom)); }
    }
</style>
